// Third Party
import DatePicker from 'vue2-datepicker';
import $ from 'jquery';
import { format } from 'date-fns';

// Services
import OrdersService from '@/app/services/main/orders/orders-service';

// Util
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { STATUS_CODES } from '@/app/constants/constants.js';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';

export default {
	name: 'ModalGenerateCsv',
	components: { DatePicker },
	directive: {},
	filters: {},
	mixins: [toastMessageMixins],
	props: {},
	data() {
		return {
			dateRange: null,
			selectedStatus: '',
			statusList: [
				{ id: 'For delivery', name: 'For delivery' },
				{ id: 'For cancellation', name: 'For cancellation' },
				{ id: 'Cancelled', name: 'Cancelled' },
				{ id: 'Out for delivery', name: 'Out for delivery' },
				{ id: 'Delivered', name: 'Delivered' },
				{ id: 'Refunded', name: 'Refunded' },
				{ id: 'Pending Payment', name: 'Pending Payment' },
			],
			isGenerateLoading: false
		}
	},
	computed: {
		validationRules() {
			let fields = {
				dateRange: {},
				selectedStatus: {}
			}
			fields = vuelidateUtil.setFieldsRequired(fields, true);
			return fields;
		},
	},
	watch: {},
	created() {},
	methods: {
		show() {
			this.dateRange = null;
			this.selectedStatus = '';
			this.$v.$reset();
            $('#generateCSVModal').modal('show');
        },
        close() {
            $('#generateCSVModal').modal('hide');
        },
		generateCSV(queryParams) {
			this.$v.$touch();

			if (this.$v.$invalid) {
				return;
			}

			const headers = {
				id: 'ORDER ID',
				productId: 'SKU / Product ID',
				productName: 'PRODUCT',
				quantity: 'QTY',
				date: 'DATE',
				soldTo: 'SOLD TO',
				address_1: 'ADDRESS 1',
				address_2: 'ADDRESS 2',
				suburb: 'SUBURB',
				state: 'STATE',
				country: 'COUNTRY',
				postcode: 'POSTCODE'
			}	

			let startDate = format(this.dateRange[0], 'yyyy-MM-dd');
			let endDate = format(this.dateRange[1], 'yyyy-MM-dd');
			
			queryParams['status'] = this.selectedStatus;
			queryParams['startDate'] = startDate;
			queryParams['endDate'] = endDate;
			
			this.isGenerateLoading = true;
			OrdersService.getOrdersReport(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.exportCSVFile(headers, res.data, `orders-report-${(new Date().toJSON().slice(0,10))}`);
					} else {
						this.showAPIErrorToast('Unable to generate report.', res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.isGenerateLoading = false;
				});
		},
		convertToCSV(objArray) {
			let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
			let str = '';
		
			for (let i = 0; i < array.length; i++) {
				let line = '';
				for (let index in array[i]) {
					if (line != '') line += ','
		
					line += array[i][index];
				}
		
				str += line + '\r\n';
			}
		
			return str;
		},
		exportCSVFile(headers, items, fileTitle) {
			if (headers) {
				items.unshift(headers);
			}
		
			// Convert Object to JSON
			var jsonObject = JSON.stringify(items);
		
			var csv = this.convertToCSV(jsonObject);
		
			var exportedFileName = fileTitle + '.csv' || 'export.csv';
		
			var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
			if (navigator.msSaveBlob) { // IE 10+
				navigator.msSaveBlob(blob, exportedFileName);
			} else {
				var link = document.createElement("a");
				if (link.download !== undefined) { // feature detection
					// Browsers that support HTML5 download attribute
					var url = URL.createObjectURL(blob);
					link.setAttribute("href", url);
					link.setAttribute("download", exportedFileName);
					link.style.visibility = 'hidden';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			}
		}
	},
	validations() {
		return this.validationRules;
	}
}